import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { Table, Row, Col, Input, Modal, Form, Select, TreeSelect, DatePicker, Button, Space, message } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import baseAxios, { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from '../../tool/axios'
import { SelectStores } from '../../component/common/Selects'
import { CheckImgs } from "../../component/common/Imgs"
import { formItemLayout, tailLayout } from '../../js/globalParam'
import _ from 'lodash'

import AddCustomerConsume from './components/AddChankangCustomerConsume'
import EditCustomerServiceInfo from './components/EditCustomerServiceInfo'

type fetchParams = {
  store_id: string | undefined,
  item_id: string | undefined,
}

type formDataTml = {
  customer_id: string | undefined,
  order_source_type: string | undefined,
  store_id: string | undefined,
  item_id: string | undefined,
  employee_id_recover: string | undefined,
  employee_name_recover: string | undefined,
  employee_id_teacher: string | undefined,
  employee_name_teacher: string | undefined,
  service_date: string | undefined,
  consume_count: number | undefined,
  consume_manual_cost: number | undefined,
  remark: string | undefined
}

let formDatas = {
  customer_id: undefined,
  order_source_type: undefined,
  store_id: undefined,
  item_id: undefined,
  employee_id_recover: undefined,
  employee_name_recover: undefined,
  employee_id_teacher: undefined,
  employee_name_teacher: undefined,
  service_date: undefined,
  consume_count: undefined,
  consume_manual_cost: undefined,
  remark: undefined
}

type itemDataTml = {
  treeData: [] | undefined,
}

let itemDatas = {
  treeData: undefined,
}

export default function CkCustomerDetail() {

  let { id }: { id: string } = useParams()

  let fetchParamsTmpl: fetchParams = {
    store_id: undefined,
    item_id: undefined
  }

  const { Column } = Table
  const { Option } = Select

  const [userData, setUserData] = useState<any[]>([])
  const [userDealData, setUserDealData] = useState<any[]>([])
  const [itemList, setItemList] = useState<any[]>([])
  const [recordList, setRecordList] = useState<any[]>([])
  const [refundList, setRefundList] = useState<any[]>([])

  const [itemData, setItemData] = useState<itemDataTml>(itemDatas)
  const [formData, setFormData] = useState<formDataTml>(formDatas)

  const [urls, setUrls] = useState<string[]>([])
  const [swiperVisible, setSiperVisible] = useState<boolean>(false)

  // 消耗
  const [byVisible, setByVisible] = useState<boolean>(false)
  const [consumeData, setConsumeData] = useState<any>({})
  const [consumeRef] = Form.useForm()

  // 转项目
  const [zxmVisible, setZxmVisible] = useState<boolean>(false)
  const [transferItemData, setTransferItemData] = useState<any>({})
  const [transferItemRef] = Form.useForm()

  // 退款
  const [tkVisible, setTkVisible] = useState<boolean>(false)
  const [refundData, setRefundData] = useState<any>({})
  const [refundRef] = Form.useForm()
  const [recoverEmployeeList, setRecoverEmployeeList] = useState<any[]>([])
  const [teacherEmployeeList, setTeacherEmployeeList] = useState<any[]>([])

  const [itemFetchParams, setItemFetchParams] = useState<fetchParams>(fetchParamsTmpl)
  // 编辑产康套餐
  const [visible, setVisible] = useState<boolean>(false)
  const [selectNormalItemData, setSelectNormalItemData] = useState([]);
  // 添加续住项目
  const [continueVisible, setContinueVisible] = useState<boolean>(false)
  const [selectContinueItemData, setSelectContinueItemData] = useState([]);

  const [yueziItemList, setYueziItemList] = useState<any>([])
  const [itemExtraList, setItemExtraList] = useState<any>([])

  const columns = [
    {
      title: '项目分类',
      dataIndex: 'item_type_name',
      key: 'item_type_name',
    },
    {
      title: '项目名称',
      dataIndex: 'item_name',
      key: 'item_name',
    },
    {
      title: '项目次数',
      dataIndex: 'up_limit_times',
      key: 'up_limit_times',
      render: (text: number, record: any, index: number) => (
        <Input value={text} style={{ width: '100px' }}
          onChange={(e) => {
            const newData = [...itemExtraList];
            newData[index] = { ...record, up_limit_times: e.target.value };

            setItemExtraList(newData);
          }}
        />
      ),
    },
    {
      title: '按需类型',
      dataIndex: 'item_need_type',
      key: 'item_need_type',
      render: (text: number, record: any, index: number) => (
        <Select value={text} style={{ width: '120px' }} allowClear
          onChange={(value: number) => {
            const newData = [...itemExtraList];
            newData[index] = { ...record, item_need_type: value };

            setItemExtraList(newData);
          }}>
          <Option key={1} value={1}>按需</Option>
          <Option key={2} value={2}>天数按需</Option>
          <Option key={3} value={3}>所内按需</Option>
        </Select>
      ),
    },
    {
      title: '按需天数',
      dataIndex: 'item_need_days',
      key: 'item_need_days',
      render: (text: number, record: any, index: number) => (
        <Input value={text} style={{ width: '100px' }}
          onChange={(e) => {
            const newData = [...itemExtraList];
            newData[index] = { ...record, item_need_days: e.target.value };

            setItemExtraList(newData);
          }}
        />
      ),
    }
  ];

  useEffect(() => {
    initData()
  }, [])

  // 客户基本信息
  useEffect(() => {
    baseAxiosNoInfo.get('/chankang_center/customer/baseInfoDetail', { params: { customer_id: id } }).then((res: any) => {
      if (res) {
        setUserData([res])

        // 产康师
        getEmployeeList(res.current_store_id)

        // 产康老师
        baseAxiosNoInfo('/global/employee_list_by_position', {
          params: {
            department_id: res.current_store_id,
            position_number: 28
          }

        }).then((res: any) => {
          if (res) {
            setTeacherEmployeeList(res)
          }
        })
      }
    })

    // 产康单项
    getSingleItemList('')
  }, [])

  // 客户详情
  const initData = () => {
    baseAxiosNoInfo.get('/chankang_center/customer/baseInfoDetail', { params: { customer_id: id } }).then((res: any) => {
      if (res) {
        setUserData([res])
      }
    })

    // baseAxiosNoInfo.get('/chankang_center/customer/detail', { params: { customer_id: id } }).then((res: any) => {
    //   if (res) {
    //     setItemList(res.customer_order_list)
    //     setRecordList(res.customer_consume_records)
    //     setRefundList(res.customer_refund_records)

    //     setUserDealData([res.customer_deal_records])
    //   }
    // })

    baseAxiosNoInfo.get('/chankang_center/customer/deal_records', { params: { customer_id: id } }).then((res: any) => {
      if (res) {
        setUserDealData([res])
      }
    })

    baseAxiosNoInfo.get('/chankang_center/customer/order_records', { params: { customer_id: id } }).then((res: any) => {
      if (res) {
        setItemList(res)
      }
    })

    baseAxiosNoInfo.get('/chankang_center/customer/consume_records', { params: { customer_id: id } }).then((res: any) => {
      if (res) {
        setRecordList(res)
      }
    })

    baseAxiosNoInfo.get('/chankang_center/customer/refund_records', { params: { customer_id: id } }).then((res: any) => {
      if (res) {
        setRefundList(res)
      }
    })
  }

  const handleChange = (value: any, attr: string) => {
    let params: any = _.cloneDeep(itemFetchParams)
    params[attr] = value

    setItemFetchParams(params)
  }

  const normalHandleSearch = () => {
    selectExtraItem("normal")
  }

  const continueHandleSearch = () => {
    selectExtraItem("continue")
  }

  const selectExtraItem = (type: string) => {
    baseAxiosNoInfo.get('/yuezi_center/package/detail', {
      params: {
        id: itemFetchParams.item_id
      }

    }).then((res: any) => {
      if (res) {
        if (type === 'normal') {
          // 若是普通项目
          setItemExtraList(res.extra_normal_item_list.map((item: any) => ({
            ...item,
            key: item.id
          })));

        } else if (type === 'continue') {
          // 若是续住项目
          setItemExtraList(res.extra_continue_item_list.map((item: any) => ({
            ...item,
            key: item.id
          })));
        }
      }
    })
  }

  const resetForm = () => {
    setItemFetchParams(fetchParamsTmpl)
    setItemExtraList("")
  }

  const onSelectNormalChange = (selectedRowKeys: any, selectedRows: any) => {
    setSelectNormalItemData(selectedRows);
  };

  const rowSelectNormal = {
    onChange: onSelectNormalChange,
  };

  // 编辑产康套餐
  const confirmNormalItem = () => {
    baseAxiosComplete.post('/chankang_center/customer/update_chankang_item', {
      customer_id: id,
      item_extra_detail: selectNormalItemData

    }).then(res => {
      if (res.status === 0) {
        message.success(`编辑成功`)

        initData()
        setVisible(false)
      }
    })
  }

  const onSelectContinueChange = (selectedRowKeys: any, selectedRows: any) => {
    setSelectContinueItemData(selectedRows);
  };

  const rowSelectContinue = {
    onChange: onSelectContinueChange,
  };

  // 添加续住项目
  const confirmContinueItem = () => {
    baseAxiosComplete.post('/chankang_center/customer/add_continue_item', {
      customer_id: id,
      item_extra_detail: selectContinueItemData

    }).then(res => {
      if (res.status === 0) {
        message.success(`添加成功`)

        initData()
        setContinueVisible(false)
      }
    })
  }

  // 查询产康师列表
  const getEmployeeList = (id: any) => {
    baseAxiosNoInfo('/global/employee_list_by_position', {
      params: {
        department_id: id,
        position_number: 5
      }

    }).then((res: any) => {
      if (res) {
        setRecoverEmployeeList(res)
      }
    })
  }

  // 查询产康单项列表
  const getSingleItemList = (id: any) => {
    baseAxiosNoInfo.get('/chankang_center/item_single/select_list').then((res: any) => {
      if (res) {
        res.forEach((el: { singles: any[], id: string }) => {
          el.singles.forEach(el2 => {
            if (el2.item_id) {
              Object.assign(el2, { item_id: el2.item_id, standard_times: el2.standard_times })
            }
          })
        })

        setItemData({
          treeData: translateToTreeData(res)
        })
      }
    })
  }

  const translateToTreeData = (data: any) => {
    return data.map((el: any) => ({
      title: el.item_type_name, // '产康分类'
      value: el.item_type_id, // '0-0'
      key: el.item_type_id, // '0-0'
      disabled: el.singles.length ? false : true,
      children: el.singles.map((el: { item_id: string, item_name: string }) => ({
        title: el.item_name, // '产康项目'
        value: el.item_id, //  '0-0-0'
        key: el.item_id, // '0-0-0'
      }))
    }))
  }

  const handleSelectChange = (value: string, attr: string) => {
    getEmployeeList(value)
    getSingleItemList(value)

    let params: any = _.cloneDeep(formData)
    params[attr] = value

    setFormData(params)
  }

  const handleSelectChangeEmployee = (value: string, attr: string, type: string) => {
    let params: any = _.cloneDeep(formData)

    if (type === 'recover') {
      params['employee_id_recover'] = value.split("&")[0]
      params['employee_name_recover'] = value.split("&")[1]

    } else if (type === 'teacher') {
      params['employee_id_teacher'] = value.split("&")[0]
      params['employee_name_teacher'] = value.split("&")[1]
    }

    setFormData(params)
  }

  // 消耗弹框
  const hanldeConsume = (el: any, type: any) => {
    consumeRef.setFieldsValue({
      store_id: undefined,
      employee_id_recover: undefined,
      employee_name_recover: undefined,
      employee_id_teacher: undefined,
      employee_name_teacher: undefined,
      consume_count: 1,
      consume_manual_cost: el.order_source_type != 1 ? el.item_manual_cost : undefined,
      consume_settlement_amount: el.order_source_type == 1 ? el.item_settlement_amount : undefined
    })

    let params: any = _.cloneDeep(formData)
    params['employee_id_recover'] = undefined
    params['employee_name_recover'] = undefined
    params['employee_id_teacher'] = undefined
    params['employee_name_teacher'] = undefined
    setFormData(params)

    setConsumeData(el)
    setByVisible(true)
  }

  const changeCancel = () => {
    setByVisible(false)
  }

  const confirmAdd = (value: any) => {
    let data = {
      customer_id: id,
      order_source_type: consumeData.order_source_type,
      order_id: consumeData.order_id,
      item_id: consumeData.item_id,
      store_id: value.store_id,
      employee_id_recover: formData.employee_id_recover,
      employee_name_recover: formData.employee_name_recover,
      employee_id_teacher: formData.employee_id_teacher,
      employee_name_teacher: formData.employee_name_teacher,
      service_date: value.service_date ? value.service_date.format('YYYY-MM-DD') : '',
      consume_count: value.consume_count,
      consume_manual_cost: value.consume_manual_cost,
      consume_settlement_amount: value.consume_settlement_amount,
      remark: value.remark
    }

    baseAxiosComplete.post('/chankang_center/customer/consume', data).then(res => {
      if (res.status === 0) {
        initData()
        setByVisible(false)
      }
    })
  }

  // 转项目弹框
  const hanldeTransferItem = (el: any, type: any) => {
    transferItemRef.setFieldsValue({
      transfer_item_id: undefined,
      transfer_item_count: undefined,
      transfer_item_amount: undefined
    })

    setTransferItemData(el)
    setZxmVisible(true)
  }

  const changeZxmCancel = () => {
    setZxmVisible(false)
  }

  const confirmTransferItem = (value: any) => {
    let data = {
      customer_id: id,
      order_source_type: transferItemData.order_source_type,
      order_id: transferItemData.order_id,
      item_id: transferItemData.item_id,
      transfer_item_id: value.transfer_item_id,
      transfer_item_count: value.transfer_item_count,
      transfer_item_amount: value.transfer_item_amount
    }

    baseAxios.post('/chankang_center/customer/transfer_item', data).then((res: any) => {
      initData()
      setZxmVisible(false)
    })
  }

  // 退款弹框
  const hanldeRefund = (el: any, type: any) => {
    refundRef.setFieldsValue({
      refund_count: undefined,
      refund_amount: undefined
    })

    setRefundData(el)
    setTkVisible(true)
  }

  const changeTkCancel = () => {
    setTkVisible(false)
  }

  const confirmRefund = (value: any) => {
    let data = {
      customer_id: id,
      order_source_type: refundData.order_source_type,
      order_id: refundData.order_id,
      item_id: refundData.item_id,
      refund_count: value.refund_count,
      refund_amount: value.refund_amount
    }

    baseAxios.post('/chankang_center/customer/refund', data).then((res: any) => {
      initData()
      setTkVisible(false)
    })
  }

  const getRecoverEmployeeList = recoverEmployeeList.map((el: any) => (<Option value={el.employee_id + '&' + el.user_name} key={el.employee_id}>{el.user_name}</Option>))
  const getTeacherEmployeeList = teacherEmployeeList.map((el: any) => (<Option value={el.employee_id + '&' + el.user_name} key={el.employee_id}>{el.user_name}</Option>))
  const getYueziItemList = yueziItemList.map((el: any) => (<Option value={el.item_id} key={el.item_id}>{el.item_name}</Option>))

  return <div className="common-level2-edit" style={{ height: '50%', overflowY: 'auto' }}>
    {/* 产康中心 -> 产康客户管理 -> 产康客户列表 -> 客户详情 */}
    <h2>客户详情</h2>

    {/* 客户操作按钮 */}
    <div className="clear" style={{ paddingLeft: 16, marginBottom: 16 }} >
      <Button size="small" onClick={() => { window.history.go(-1) }} >返回</Button>

      {userDealData[0] != null ?
        (<Button type="primary" size="small" style={{ marginLeft: 10 }}
          onClick={() => {
            setVisible(true)

            setItemFetchParams(fetchParamsTmpl)
            setItemExtraList("")
          }}
        >编辑产康套餐</Button>)
        : null
      }
      {userDealData[0] != null ?
        (<Button type="primary" size="small" style={{ marginLeft: 10 }}
          onClick={() => {
            setContinueVisible(true)

            setItemFetchParams(fetchParamsTmpl)
            setItemExtraList("")
          }}
        >添加续住项目</Button>)
        : null
      }

      <Button type="primary" size="small" style={{ marginLeft: 10 }} >
        <Link to={"/ck_customer_order/" + id}>录入订单</Link>
      </Button>
      <AddCustomerConsume customerID={userData[0]?.customer_id} storeID={userData[0]?.current_store_id} onChange={() => {
        initData()
      }} />
      <EditCustomerServiceInfo customerID={userData[0]?.customer_id} storeID={userData[0]?.current_store_id} userData={userData[0]} onChange={() => {
        initData()
      }} />
    </div>

    {/* 客户基本信息 */}
    <div style={{ padding: '0 30px 30px' }}>
      <Table dataSource={userData} scroll={{ x: 'max-content' }} bordered={true} pagination={false} rowKey="customer_id">
        <Column title="客户姓名" dataIndex="customer_name" key="customer_name" />
        <Column title="手机号码" dataIndex="customer_phone" key="customer_phone" />
        <Column title="客户类型" dataIndex="customer_type_desc" key="customer_type_desc" />
        <Column title="产康消费金额" dataIndex="chankang_buy_amount" key="chankang_buy_amount" />
        <Column title="产康顾问" dataIndex="employee_name_adviser" key="employee_name_adviser" />
        <Column title="主产康师" dataIndex="main_recover_name" key="main_recover_name" />
        <Column title="副产康师" dataIndex="vice_recover_name" key="vice_recover_name" />
      </Table>

      {userData[0]?.customer_type === 2 ?
        <Table dataSource={userData} scroll={{ x: 'max-content' }} bordered={true} pagination={false} rowKey="customer_id">
          <Column title="入住状态" dataIndex="check_in_status_desc" key="check_in_status_desc" />
          <Column title="入住信息" dataIndex="room_number" key="room_number" />
          <Column title="入所日期" dataIndex="check_in_time" key="check_in_time" />
          <Column title="出所日期" dataIndex="check_out_time" key="check_out_time" />
        </Table>
        : null}
    </div>

    {/* 客户月子签单 */}
    {userDealData[0] != null ? <h2>签单信息</h2> : null}
    {userDealData[0] != null ?
      <div style={{ padding: '0 30px 30px' }}>
        <Row style={{ marginBottom: 8, marginTop: 5 }} wrap>
          <Col span={6}>签单日期：{userDealData[0].deal_date}</Col>
          <Col span={6}>签单门店：{userDealData[0].deal_store_name}</Col>
        </Row>

        <Row style={{ marginBottom: 8, marginTop: 5 }} wrap>
          <Col span={6}>签单套餐：{userDealData[0].deal_item_name}</Col>
          <Col span={6}>套餐天数：{userDealData[0].item_days}</Col>
          <Col span={6}>赠送天数：{userDealData[0].gift_days}</Col>
        </Row>

        <Row style={{ marginBottom: 8, marginTop: 5 }} wrap>
          <Col span={6}>合同金额：{userDealData[0].agreement_amount}</Col>
          <Col span={6}>已收金额：{userDealData[0].total_pay_amount}</Col>
          <Col span={6}>合同凭证：
            <Button onClick={() => {
              setUrls(userDealData[0].deal_prov_pic_list.split(','))
              setSiperVisible(true)
            }} size="small" >查看</Button>
          </Col>
        </Row>

        <Row style={{ marginBottom: 8, marginTop: 5 }} wrap>
          <Col span={24}>备注：{userDealData[0].remark}</Col>
        </Row>
      </div>
      : null
    }

    {/* 客户产康订单 */}
    <h2>订单记录</h2>
    <div style={{ padding: '0 30px 30px' }}>
      {itemList.map((el: any) => <div style={{ marginBottom: 30 }}>
        <h3 style={{ marginBottom: 10 }}>订单编号：{el.order_code}</h3>
        {el.order_date ?
          <h4 style={{ marginBottom: 10 }}>
            订单日期：{el.order_date}
            {el.adviser_employee ? '，产康顾问：' + el.adviser_employee + '' : ''}
            {el.recover_employee ? '，产康师：' + el.recover_employee + '' : ''}
          </h4>
          : ''
        }

        {/* 月子套餐的产康项目 */}
        {el.order_code === '月子套餐签单' && <Table dataSource={el.order_item_list} scroll={{ x: 'max-content' }} bordered={true} pagination={false} rowKey="item_id">
          <Column title="订单类型" dataIndex="order_source_type" key="order_source_type" render={(e: number) => {
            switch (e) {
              case 3:
                return '月子额外赠送'
              case 4:
                return '月子套餐赠送'
            }
          }} />
          <Column title="项目分类" dataIndex="item_type_name" key="item_type_name" />
          <Column title="项目名称" dataIndex="item_name" key="item_name" />
          <Column title="项目标签" dataIndex="item_label_desc" key="item_label_desc" />
          <Column title="项目总次数" dataIndex="total_count" key="total_count" />
          <Column title="消耗次数" dataIndex="use_count" key="use_count" />
          <Column title="剩余次数" dataIndex="left_count" key="left_count" />
          <Column title="操作" render={(e: any) => {
            if (e.item_need_type || e.left_count > 0) {
              return <Space size="middle">
                <Button size='small' onClick={() => { hanldeConsume(e, 4) }}>
                  消耗
                </Button>

                <Button size='small' onClick={() => { hanldeTransferItem(e, 2) }}>
                  转项目
                </Button>
              </Space>

            } else {
              return null
            }
          }} />
        </Table>}

        {/* 产康订单项目 */}
        {el.order_code != '月子套餐签单' && <Table dataSource={el.order_item_list} scroll={{ x: 'max-content' }} bordered={true} pagination={false} rowKey="item_id">
          <Column title="订单类型" dataIndex="order_source_type" key="order_source_type" render={(e: number) => {
            switch (e) {
              case 1:
                return '产康购买'
              case 2:
                return '产康赠送'
              case 3:
                return '月子额外赠送'
              case 4:
                return '月子套餐赠送'
            }
          }} />
          <Column title="项目名称" dataIndex="item_name" key="item_name" />
          <Column title="项目总次数" dataIndex="total_count" key="total_count" />
          <Column title="消耗次数" dataIndex="use_count" key="use_count" />
          <Column title="剩余次数" dataIndex="left_count" key="left_count" />
          <Column title="金额" dataIndex="item_amount" key="item_amount" />
          <Column title="备注" dataIndex="remark" key="remark" />
          <Column title="操作" render={(e: any) => {
            if (e.order_source_type == 1 && e.left_count > 0) {
              return <Space size="middle">
                <Button size='small' onClick={() => { hanldeConsume(e, 1) }}>
                  消耗
                </Button>

                <Button size='small' onClick={() => { hanldeTransferItem(e, 2) }}>
                  转项目
                </Button>

                <Button size='small' onClick={() => { hanldeRefund(e, 3) }}>
                  退款
                </Button>
              </Space>

            } else if (e.item_need_type || e.left_count > 0) {
              return <Space size="middle">
                <Button size='small' onClick={() => { hanldeConsume(e, 1) }}>
                  消耗
                </Button>

                <Button size='small' onClick={() => { hanldeTransferItem(e, 2) }}>
                  转项目
                </Button>
              </Space>

            } else {
              return null
            }
          }} />
        </Table>}
      </div>)}
    </div>

    {/* 客户项目消耗 */}
    <h2>消耗记录</h2>
    <div style={{ padding: '0 30px 30px' }}>
      <Table dataSource={recordList} scroll={{ x: 'max-content' }} bordered={true} pagination={false} rowKey="store_id">
        <Column title="门店" dataIndex="store_name" key="store_name" />
        <Column title="订单类型" dataIndex="order_source_type" key="order_source_type" />
        <Column title="项目名称" dataIndex="item_name" key="item_name" />
        <Column title="服务日期" dataIndex="service_start_time" key="service_start_time" />
        <Column title="产康顾问" dataIndex="employee_name_adviser" key="employee_name_adviser" />
        <Column title="产康师" dataIndex="employee_name_recover" key="employee_name_recover" />
        <Column title="产康老师" dataIndex="employee_name_teacher" key="employee_name_teacher" />
        <Column title="手工费" dataIndex="manual_cost_amount" key="manual_cost_amount" />
        <Column title="结转金额" dataIndex="settlement_amount" key="settlement_amount" />
        <Column title="创建时间" dataIndex="create_time" key="create_time" />
      </Table>
    </div>

    {/* 客户项目退款 */}
    <h2>退款记录</h2>
    <div style={{ padding: '0 30px 30px' }}>
      {userData[0] != null ?
        <Row style={{ marginBottom: 8, marginTop: 5 }} wrap>
          <Col span={6}>客户姓名：{userData[0].customer_name}</Col>
          <Col span={6}>客户手机号：{userData[0].customer_phone}</Col>
          <Col span={6}>产康消费金额：{userData[0].chankang_buy_amount ? userData[0].chankang_buy_amount : 0}元</Col>
        </Row>
        : null
      }

      {userData[0] != null && userData[0].room_number != null ?
        <Row style={{ marginBottom: 8, marginTop: 5 }} wrap>
          <Col span={6}>入住状态：{userData[0].check_in_status_desc}</Col>
          <Col span={6}>入所日期：{userData[0].check_in_time}</Col>
          <Col span={6}>出所日期：{userData[0].check_out_time}</Col>
        </Row>
        : null
      }

      {userData[0] != null && userData[0].room_number != null ?
        <Row style={{ marginBottom: 8, marginTop: 5 }} wrap>
          <Col span={24}>入住信息：{userData[0].room_number}</Col>
        </Row>
        : null
      }

      <Table style={{ marginTop: '25px' }} dataSource={refundList} scroll={{ x: 'max-content' }} bordered={true} pagination={false} rowKey="store_id">
        <Column title="门店" dataIndex="store_name" key="store_name" />
        <Column title="退款日期" dataIndex="refund_date" key="refund_date" />
        <Column title="退款项目" dataIndex="refund_item_name" key="refund_item_name" />
        <Column title="退款次数" dataIndex="refund_count" key="refund_count" />
        <Column title="退款金额" dataIndex="refund_amount" key="refund_amount" />
      </Table>
    </div>

    {/* 项目消耗弹窗 */}
    <Modal title='项目消耗' visible={byVisible} onCancel={changeCancel} footer={false} width="450px">
      <Form {...formItemLayout} style={{ padding: '10px' }} form={consumeRef} onFinish={confirmAdd} >
        <Form.Item label="客户姓名" >{userData[0]?.customer_name}</Form.Item>
        <Form.Item label="手机号码" >{userData[0]?.customer_phone}</Form.Item>
        <Form.Item label="项目名称" >{consumeData.item_name}</Form.Item>
        <Form.Item label="剩余次数" >{consumeData.left_count}</Form.Item>

        <Form.Item label="服务日期" name="service_date">
          <DatePicker placeholder="不选则默认当前日期" style={{ width: 200 }} />
        </Form.Item>

        <Form.Item label="产康师" name="employee_id_recover">
          <Select style={{ width: 200 }} value={formData.employee_id_recover} showSearch
            filterOption={(input, option) => (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())}
            onChange={(value: string, option: any) => { handleSelectChangeEmployee(value, option, 'recover') }}
            placeholder="产康师">
            {getRecoverEmployeeList}
          </Select>
        </Form.Item>

        <Form.Item label="产康老师" name="employee_id_teacher">
          <Select style={{ width: 200 }} value={formData.employee_id_teacher} showSearch
            filterOption={(input, option) => (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())}
            onChange={(value: string, option: any) => { handleSelectChangeEmployee(value, option, 'teacher') }}
            placeholder="产康老师">
            {getTeacherEmployeeList}
          </Select>
        </Form.Item>

        <Form.Item label="消耗次数" name="consume_count" rules={[{ required: true, message: '请填写次数' }]} >
          <Input style={{ width: 200 }} />
        </Form.Item>

        <Form.Item label="手工费" name="consume_manual_cost" >
          <Input placeholder="" style={{ width: 200 }} />
        </Form.Item>

        <Form.Item label="结转金额" name="consume_settlement_amount" >
          <Input placeholder="" style={{ width: 200 }} />
        </Form.Item>

        <Form.Item {...tailLayout}>
          <Button type="primary" htmlType="submit">提交</Button>
        </Form.Item>
      </Form>
    </Modal>

    {/* 转项目弹窗 */}
    <Modal title='转项目' visible={zxmVisible} onCancel={changeZxmCancel} footer={false} width="450px">
      <Form name="validate_other" {...formItemLayout} form={transferItemRef} onFinish={confirmTransferItem} >
        <Form.Item label="客户姓名" >{userData[0]?.customer_name}</Form.Item>
        <Form.Item label="手机号码" >{userData[0]?.customer_phone}</Form.Item>
        <Form.Item label="项目名称" >{transferItemData.item_name}</Form.Item>
        <Form.Item label="剩余次数" >{transferItemData.left_count}</Form.Item>

        <Form.Item label="转项目" name='transfer_item_id' rules={[{ required: true, message: '必须选择项目' }]} >
          <TreeSelect
            showSearch
            multiple={true}
            allowClear
            treeData={itemData.treeData}
            filterTreeNode={(inputValue: any, treeNode: any) => (treeNode.title.indexOf(inputValue) != -1)}
          />
        </Form.Item>

        <Form.Item label="转次数" name="transfer_item_count" rules={[{ required: true, message: '请填写次数' }]} >
          <Input placeholder="" />
        </Form.Item>

        <Form.Item label="转金额" name="transfer_item_amount" rules={[{ required: true, message: '请填写金额' }]} >
          <Input placeholder="" />
        </Form.Item>

        <Form.Item {...tailLayout}>
          <Button type="primary" htmlType="submit">提交</Button>
        </Form.Item>
      </Form>
    </Modal>

    {/* 项目退款弹窗 */}
    <Modal title='项目退款' visible={tkVisible} onCancel={changeTkCancel} footer={false} width="450px">
      <Form {...formItemLayout} form={refundRef} onFinish={confirmRefund} >
        <Form.Item label="客户姓名" >{userData[0]?.customer_name}</Form.Item>
        <Form.Item label="手机号码" >{userData[0]?.customer_phone}</Form.Item>
        <Form.Item label="项目名称" >{refundData.item_name}</Form.Item>
        <Form.Item label="剩余次数" >{refundData.left_count}</Form.Item>

        <Form.Item label="退款次数" name="refund_count" rules={[{ required: true, message: '请填写退款次数' }]} >
          <Input placeholder="" />
        </Form.Item>

        <Form.Item label="退款金额" name="refund_amount" rules={[{ required: true, message: '请填写退款金额' }]} >
          <Input placeholder="" />
        </Form.Item>

        <Form.Item {...tailLayout}>
          <Button type="primary" htmlType="submit">提交</Button>
        </Form.Item>
      </Form>
    </Modal>

    {/* 编辑产康套餐 */}
    <Modal visible={visible} title="编辑产康套餐" width={1100} footer={null}
      onCancel={() => {
        setVisible(false)

        setItemFetchParams(fetchParamsTmpl)
        setItemExtraList("")
      }}
    >
      <div style={{ marginBottom: '20px' }}>
        <Space>
          <SelectStores onChange={(value: string) => {
            handleChange(value, 'store_id')
            handleChange('', 'item_id')

            axiosTable.get('/yuezi_center/put_on_off/page_list', {
              params: {
                store_id: value,
                page_num: 1,
                page_size: 50
              }

            }).then((data: any) => {
              if (data) {
                setYueziItemList(data.records)
              }
            })
          }}
            value={itemFetchParams.store_id}
          />
          <Select style={{ width: '200px' }} onChange={(value: string) => { handleChange(value, 'item_id') }} value={itemFetchParams.item_id} >
            {getYueziItemList}
          </Select>

          <Button icon={<SearchOutlined />} onClick={normalHandleSearch}>查询</Button>
          <Button icon={<RedoOutlined />} onClick={resetForm}>重置</Button>
        </Space>
      </div>

      <Table rowSelection={rowSelectNormal} dataSource={itemExtraList} columns={columns} pagination={false} />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px' }}>
        <Button type="primary" onClick={confirmNormalItem}>提交</Button>
      </div>
    </Modal>

    {/* 添加续住项目 */}
    <Modal visible={continueVisible} title="添加续住项目" width={1100} footer={null}
      onCancel={() => {
        setContinueVisible(false)

        setItemFetchParams(fetchParamsTmpl)
        setItemExtraList("")
      }}
    >
      <div style={{ marginBottom: '20px' }}>
        <Space>
          <SelectStores onChange={(value: string) => {
            handleChange(value, 'store_id')
            handleChange('', 'item_id')

            axiosTable.get('/yuezi_center/put_on_off/page_list', {
              params: {
                store_id: value,
                page_num: 1,
                page_size: 50
              }

            }).then((data: any) => {
              if (data) {
                setYueziItemList(data.records)
              }
            })
          }}
            value={itemFetchParams.store_id}
          />
          <Select style={{ width: '200px' }} onChange={(value: string) => { handleChange(value, 'item_id') }} value={itemFetchParams.item_id} >
            {getYueziItemList}
          </Select>

          <Button icon={<SearchOutlined />} onClick={continueHandleSearch}>查询</Button>
          <Button icon={<RedoOutlined />} onClick={resetForm}>重置</Button>
        </Space>
      </div>

      <Table rowSelection={rowSelectContinue} dataSource={itemExtraList} columns={columns} pagination={false} />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px' }}>
        <Button type="primary" onClick={confirmContinueItem}>提交</Button>
      </div>
    </Modal>

    <CheckImgs tinyURL={urls} visible={swiperVisible} onCancel={() => { setSiperVisible(false) }} />
  </div>
}